import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, useState } from 'react';
const CARD_SHELL = 'cp-relative cp-flex cp-min-h-[88px] cp-h-full cp-w-full cp-flex-col cp-gap-[var(--spacing-03)] cp-items-start cp-justify-start cp-box-border cp-p-[var(--spacing-04)] cp-rounded-[var(--border-radius-16)] cp-border-0 cp-bg-[var(--white)] cp-shadow-[inset_0_0_0_1px_var(--button-ghost-border,var(--black-10))] hover:cp-bg-[var(--hover)]';
export const ClawAgentCard = /*#__PURE__*/ forwardRef(({ title, icon, dataCy, className, actions, onClick }, ref)=>{
    const [isHovered, setIsHovered] = useState(false);
    const resolvedIcon = typeof icon === 'function' ? icon(isHovered) : icon;
    const cardClassName = classNames(CARD_SHELL, actions && 'cp-group', onClick && 'cp-cursor-pointer', className);
    const hoverHandlers = {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    };
    const body = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "cp-flex cp-w-full cp-items-start cp-justify-between cp-gap-[var(--spacing-03)]",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "cp-shrink-0",
                        children: resolvedIcon
                    }),
                    actions ? /*#__PURE__*/ _jsx("div", {
                        className: "cp-flex cp-opacity-0 cp-pointer-events-none cp-gap-[var(--spacing-02)] group-hover:cp-opacity-100 group-hover:cp-pointer-events-auto group-focus-within:cp-opacity-100 group-focus-within:cp-pointer-events-auto",
                        children: actions
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "cp-line-clamp-2 cp-text-left body-long-01 cp-text-[var(--text-primary)]",
                children: title
            })
        ]
    });
    if (onClick && !actions) {
        return /*#__PURE__*/ _jsx("button", {
            ref: ref,
            type: "button",
            "data-cy": dataCy,
            onClick: onClick,
            title: title,
            className: cardClassName,
            ...hoverHandlers,
            children: body
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        "data-cy": dataCy,
        role: onClick ? 'button' : undefined,
        tabIndex: onClick ? 0 : undefined,
        onClick: onClick,
        onKeyDown: onClick ? (event)=>{
            if (event.target === event.currentTarget && (event.key === 'Enter' || event.key === ' ')) {
                event.preventDefault();
                onClick();
            }
        } : undefined,
        title: title,
        className: cardClassName,
        ...hoverHandlers,
        children: body
    });
});
ClawAgentCard.displayName = 'ClawAgentCard';
